import { redirect } from 'react-router-dom';
import Authentication from '../components/Authentication';
import backend from '../util/backend.jsx';
import { setAuthToken, setAccess, setUser } from '../util/auth.jsx'

function AuthenticationPage() {
  return <Authentication />;
}

export default AuthenticationPage;

export async function action({ request }) {
  const searchParams = new URL(request.url).searchParams;
  const mode = searchParams.get('mode') || 'login';

  const data = await request.formData();
  const authData = {
    email: data.get('email'),
    password: data.get('password'),
  };

  const response = await fetch(`https://${backend}/${mode}`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(authData)
  });
  const result = await response.json();

  if (response.status === 422 || response.status === 401) {
    return {errors: [result.message]};
  }

  if (!response.ok) {
    return {errors: ['Could not authenticate.']};
  }

  const token = result.token;
  const access = result.access;
  const email  = data.get('email');

  setAuthToken(token);
  setAccess(access);
  setUser(email);

  return redirect('/');
}
